<template>
  <div class="footer-msg">
    <div class="footer-main">
      <!-- <div
        class="managed-service"
        v-for="(item, index) in serviceList"
        :key="index"
      >
        <div class="managed-service-title">{{ item.title }}</div>
        <div
          class="managed-service-item"
          v-for="(every, i) in item.children"
          :key="i"
        >
          {{ every }}
        </div>
      </div> -->
        <div class="managed-relation">
        <div class="managed-relation-all">联系我们</div>
        <div class="managed-relation-com"><a href="mailto:business@qdbroadcast.com">business@qdbroadcast.com</a></div>
      </div>
      <div class="attention">
        <div class="attention-item">扫描关注二维码</div>
        <img
          src="../../../../assets/email.png"
          alt=""
          width="108"
          height="108"
        />
        <div class="attention-cal">产品及服务咨询：010-65565070</div>
      </div>
    </div>
    <div class="footer-title">
      <div class="title-one">
        Copyright © 2023. 北京奇点智播科技有限公司 All rights reserved.
      </div>
      <div class="title-two">
        <span><a href="https://beian.miit.gov.cn" target="_blank">京ICP备2022018922号-1</a></span>  | 
         <span class="http-center">京网文[2023]1268-037号</span>     |  
         <span><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502052282" target="_blank"><img src="../../../../assets/reference.png" alt="">京公网安备11010502052282号</a></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // serviceList: [
      //   {
      //     title: "云管理服务",
      //     children: ["云运维管理服务", "云管理平台", "云管理工具"]
      //   },
      //   {
      //     title: "云管理服务",
      //     children: [
      //       "云运维管理服务",
      //       "云管理平台",
      //       "云管理工具",
      //       "云管理工具",
      //       "云管理工具"
      //     ]
      //   },
      //   {
      //     title: "云管理服务",
      //     children: ["云运维管理服务", "云管理平台", "云管理工具"]
      //   },
      //   {
      //     title: "云管理服务",
      //     children: [
      //       "云运维管理服务",
      //       "云管理平台",
      //       "云管理工具",
      //       "云管理工具",
      //       "云管理工具"
      //     ]
      //   }
      // ]
    };
  }
};
</script>
<style lang="less" scoped>
@import "./webstat.less";
</style>



// WEBPACK FOOTER //
// src/views/home/components/webstat/webstat.vue